import "react-app-polyfill/ie11";
import "mdn-polyfills/Object.entries";
import "mdn-polyfills/Array.prototype.find";

async function loadPolyfills() {
  if (
    !(
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    )
  ) {
    await import("intersection-observer");
  }

  if (
    typeof Blob !== "undefined" &&
    (typeof FormData === "undefined" || !FormData.prototype.keys)
  ) {
    await import("formdata-polyfill");
  }

  if (!("scrollBehavior" in document.documentElement.style)) {
    const smoothscroll = await import("smoothscroll-polyfill");

    smoothscroll.polyfill();
  }
}

export { loadPolyfills };
